module.exports = __webpack_public_path__ + "static/media/premium-tools.8afd72bd.png";